import { createSelector } from '@reduxjs/toolkit';

export const get = state => state.attachments;

export const filestackCredentials = createSelector(get, state => state.filestack || {});
